import React, { useState, useEffect } from 'react';
import { auth, oidcProvider, signInWithRedirect, getRedirectResult } from './firebase'; // Import from firebase.js
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  // Listen for the authentication state change
  useEffect(() => {
    // Check if the user is already signed in from the redirect result
    getRedirectResult(auth).then((result) => {
      if (result) {
        setUser(result.user);
        console.log('User authenticated via OIDC:', result);
      }
    });
  }, []);

  // Trigger the OIDC login with Azure Entra ID
  const loginWithAzure = async () => {
    try {
      await signInWithRedirect(auth, oidcProvider); // Initiates the login redirect flow with OIDC provider
    } catch (error) {
      console.error("Authentication Error: ", error.message);
    }
  };

  // Handle Logout
  const logout = () => {
    auth.signOut();
    setUser(null);
  };

  return (
    <div className="App">
      <h1>Login with Azure Entra ID through Firebase</h1>

      {/* Login button */}
      <button onClick={loginWithAzure}>Login with Azure Entra ID</button>

      {/* Show user data */}
      {user && (
        <div>
          <h2>User Info</h2>
          <p>Name: {user.displayName}</p>
          <p>Email: {user.email}</p>
        </div>
      )}

      {/* Logout button */}
      {user && <button onClick={logout}>Logout</button>}
    </div>
  );
}

export default App;
